import { render, staticRenderFns } from "./QuickAddCalendarModal.vue?vue&type=template&id=08bf21f0&scoped=true&class=fill-height&"
import script from "./QuickAddCalendarModal.vue?vue&type=script&lang=ts&"
export * from "./QuickAddCalendarModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddCalendarModal.vue?vue&type=style&index=0&id=08bf21f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf21f0",
  null
  
)

export default component.exports